import React, { useState, useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';

import CriticalElementFormView from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/critical-element-form/critical-element-form-view';
import toast from 'components/partials/toast/toast';

import api from 'api';

import { useCriticalElementForm } from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/context/context';

const CriticalElementForm = ({ data, isEditing, isCreation, userId }) => {
  const [generationLoading, setGenerationLoading] = useState(false);

  const { control, setValue, getValues, clearErrors } =
    useCriticalElementForm();
  const isDisabled = (data && !isEditing) || generationLoading;

  const {
    fields: detailFields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: 'details',
  });

  useEffect(() => {
    if (data?.details?.length === 0 && isCreation) {
      append({ category: '', focusArea: '', subArea: '', options: [] });
    }
  }, [data?.details?.length, isCreation, append]);

  const generateSummary = async () => {
    setGenerationLoading(true);

    const formData = getValues();

    const elementData = {
      ...data,
      metric: formData.metric,
      stage: formData.stage,
      relativeToLastYear: formData.relativeToLastYear,
      details: formData.details.map((item) => ({
        ...item,
        options: item.options ? [].concat(item.options) : [],
      })),
    };

    try {
      const response = await api.generateCriticalElementSummary({
        userId,
        elementData,
      });

      if (response?.data?.summary) {
        setValue('summary', response.data.summary);
        clearErrors('summary');
      }
    } catch (error) {
      toast.error({ title: 'Error while generating AI description' });
      console.error('Error while generating AI description', error);
    } finally {
      setGenerationLoading(false);
    }
  };

  const initialShowNote = data?.note?.length > 0;

  return (
    <CriticalElementFormView
      detailFields={detailFields}
      append={append}
      remove={remove}
      isDisabled={isDisabled}
      control={control}
      clearErrors={clearErrors}
      generateSummary={generateSummary}
      generationLoading={generationLoading}
      initialShowNote={initialShowNote}
      setValue={setValue}
    />
  );
};

export default CriticalElementForm;
